import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { setTier } from "./reward";
import WagmiConnect from "components/WagmiConnect/WagmiConnect";
import { fetchSigner } from "@wagmi/core";
import { tierName } from "./const";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  textField: {
    marginBottom: theme.spacing(2),
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
}));

export default function RewardTierEdit({ tier, reload, paymentCoin }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const [formValues, setFormValues] = useState({
    seller: tier.seller,
    buyer: tier.buyer,
    collectionOwner: tier.collectionOwner,
  });
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const signer = await fetchSigner();
      await setTier(signer, tier.id, paymentCoin?.address, formValues);
      reload();
      handleClose();
    } catch (e) {
      console.error(e);
      alert("Error updating tier");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button onClick={handleOpen}>Edit</Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2 id="transition-modal-title">
              Edit {tierName[tier?.id]} (Reward per 1{" "}
              {paymentCoin?.name})
            </h2>

            <WagmiConnect />
            <p></p>

            <form className={classes.form} onSubmit={handleSubmit}>
              <TextField
                className={classes.textField}
                label="Seller Reward"
                name="seller"
                type="number"
                value={formValues.seller}
                onChange={handleChange}
              />
              <TextField
                className={classes.textField}
                label="Buyer Reward"
                name="buyer"
                type="number"
                value={formValues.buyer}
                onChange={handleChange}
              />
              <TextField
                className={classes.textField}
                label="Collection Reward"
                name="collectionOwner"
                type="number"
                value={formValues.collectionOwner}
                onChange={handleChange}
              />
              <Button
                className={classes.submitButton}
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
              >
                {loading ? "Loading..." : "Submit"}
              </Button>
            </form>
          </div>
        </Fade>
      </Modal>
    </>
  );
}

// create props validation
RewardTierEdit.propTypes = {
  tier: PropTypes.shape({
    id: PropTypes.number.isRequired,
    seller: PropTypes.number.isRequired,
    buyer: PropTypes.number.isRequired,
    collectionOwner: PropTypes.number.isRequired,
  }).isRequired,
  reload: PropTypes.func.isRequired,
  paymentCoin: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
  }).isRequired,
};
